'use client';

import * as React from 'react';
import LandingPage from './landing-page';
import { useAuth } from '@/context/auth-context';
import { useRouter } from 'next/navigation';
import MainView from '@/components/main-view';
import { Suspense } from 'react';
import LoadingAnimation from '@/components/loading-animation';

function AppHomePage() {
  const { user, loading } = useAuth();
  const router = useRouter();

  // While loading, we can show a blank screen or a minimal loader
  if (loading) {
      return <LoadingAnimation />;
  }

  // If there is a user, it means they are logged in.
  // Instead of showing the landing page, we should show them the app.
  if (user) {
      return <MainView />;
  }

  // If there is no user, show the landing page.
  return <LandingPage />;
}

export default function Home() {
    return (
        <Suspense fallback={<LoadingAnimation />}>
            <AppHomePage />
        </Suspense>
    );
}
